import { render, staticRenderFns } from "./SideBarItem.vue?vue&type=template&id=34992c96&scoped=true&xmlns%3Av-popover=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./SideBarItem.vue?vue&type=script&lang=js"
export * from "./SideBarItem.vue?vue&type=script&lang=js"
import style0 from "./SideBarItem.vue?vue&type=style&index=0&id=34992c96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34992c96",
  null
  
)

export default component.exports